import { Platform, StyleSheet, View } from 'react-native';
import React, { useMemo } from 'react';
import { FLASH_IMAGE, INTEREST_RATE, SECURITY_IMAGE } from './constant';
import InfoText from './InfoText';
import { Image } from "../../image/Image";
import { ImageSizeTokens } from "@voltmoney/schema";
let SvgUri;
if (Platform.OS !== 'web') {
    const RNSVG = require('react-native-svg');
    SvgUri = RNSVG?.SvgUri;
}
const renderImage = (url) => {
    return useMemo(() => {
        return React.createElement(React.Fragment, null, Platform.OS === 'web'
            && React.createElement(Image, { size: ImageSizeTokens.SIZE_46, uri: url }));
    }, [url]);
};
const InfoSection = () => {
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: styles.flashImageContainer },
            React.createElement(View, { style: styles.imageRender },
                Platform.OS !== 'web'
                    && React.createElement(SvgUri, { uri: FLASH_IMAGE }),
                Platform.OS === 'web' && renderImage(FLASH_IMAGE)),
            React.createElement(View, null,
                React.createElement(InfoText, { label: "Instant and hassle-free" }))),
        React.createElement(View, { style: styles.divider }),
        React.createElement(View, { style: styles.rateImageContainer },
            React.createElement(View, { style: styles.imageRender },
                Platform.OS !== 'web'
                    && React.createElement(SvgUri, { uri: INTEREST_RATE }),
                Platform.OS === 'web' && renderImage(INTEREST_RATE)),
            React.createElement(View, { style: styles.rateTextRender },
                React.createElement(InfoText, { label: "Low interest" }),
                React.createElement(InfoText, { label: "rate " }))),
        React.createElement(View, { style: styles.divider }),
        React.createElement(View, { style: styles.securityImageContainer },
            React.createElement(View, { style: styles.imageRender },
                Platform.OS !== 'web'
                    && React.createElement(SvgUri, { uri: SECURITY_IMAGE }),
                Platform.OS === 'web' && renderImage(SECURITY_IMAGE)),
            React.createElement(View, { style: styles.securityTextRender },
                React.createElement(InfoText, { label: "Secure & transparent" })))));
};
export default InfoSection;
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'row',
        borderRadius: 16,
        borderWidth: 1,
        borderColor: '#E7EBFA',
        marginHorizontal: 16,
        marginTop: 16,
        backgroundColor: 'white',
    },
    flashImageContainer: {
        paddingLeft: 24,
        paddingVertical: 20,
        alignItems: 'center',
        justifyContent: 'center',
        width: '30%',
    },
    rateImageContainer: {
        paddingVertical: 20,
        alignItems: 'center',
        justifyContent: 'center',
        width: '30%',
    },
    securityImageContainer: {
        paddingRight: 24,
        paddingVertical: 20,
        alignItems: 'center',
        justifyContent: 'center',
        width: '30%',
    },
    imageRender: {
        marginBottom: 4,
    },
    rateTextRender: {
        paddingHorizontal: 10,
        justifyContent: 'center',
        alignContent: 'center'
    },
    rateText: {
        flexDirection: 'row',
    },
    securityTextRender: {
        paddingHorizontal: 10,
    },
    divider: {
        marginHorizontal: 10,
        borderWidth: 1,
        borderColor: '#F3F5FC',
        marginVertical: 37,
    },
});
